import { Helmet } from 'react-helmet-async';
import styles from './TermsScreen.module.css';
import PrivacyModal from '../components/login/PrivacyModal';

/**
 * @author smyun
 * @date 2025-12-15
 * @remark 개인정보보호 법률 페이지 스크린
 * @param props None
 * @returns <PolicyModal>
 */
function PrivacyScreen() {
  return (
    <>
      <Helmet>
        <title>이용약관 - 모두의지도</title>
        <meta name="description" content="모두의지도 개인정보처리방침" />
      </Helmet>
      <div>
        <div className={styles.top_div}>
          <PrivacyModal />
        </div>
      </div>
    </>
  );
}

export default PrivacyScreen;
